import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const MonitorIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "monitor",
  "MonitorIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M13.3337 6.66536V12.6654M8.00033 3.33203V12.6654M2.66699 8.66536V12.6654" stroke={colorList[0]} strokeWidth="1.33333" strokeLinecap="square" strokeOpacity="1"/></g></svg>
);

export default MonitorIcon;
